/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Button } from "../../../components/Component";
import Swal from "sweetalert2";
const AdminUserDataUpdate = ({ ...props }) => {
    const [load, setload] = useState(true)
    
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        activeStatus:"O",
        employmentId: 0,
        employmentRefId: 0
    });


    const getdata = async () => {
      
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            MonthId: Number(props.month),
            EmploymentRefId: props.parent,
            YearId: Number(props.year),
        }
        await fetch(process.env.REACT_APP_API_LINK+'api/Main/Dashdata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    console.log(data)
                    if (data !== "No data") {
                        setFormData({
                            ...formData,
                            activeStatus: data.activeStatus,
                            employmentId: data.employmentId,
                            employmentRefId: data.employmentRefId
                        });
                      
                    } else {
                        setFormData({
                            ...formData,
                            activeStatus: "O",
                            employmentId: data.employmentId,
                            employmentRefId: data.employmentRefId
                        });
                    }
                   
                    setload(false)
                })


    };

    

    const check = async () => {

        const sendData = {
            EmploymentRefId: Number(props.parent),
            UserId: Number(localStorage.getItem("userId")),
            Monthid: Number(props.month),
            YearId: Number(props.year)
        }
        //console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK+'api/Main/Checkdraft2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    if (data === "NO") {
                        window.location.href = props.path

                    }
                    else if (data === "Previous Month Data Not Submitted") {
                        Swal.fire({
                            icon: "warning",
                            title: "Data Not Submitted",
                            text: "Previous Month Data Not Submitted",
                            focusConfirm: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: data.month + " " + data.yearId,
                            text: data.month + " " + data.yearId + " Data  is Already in Draft",
                            focusConfirm: false,
                        });
                    }

                })


    };
    const viewpage = async () => {

        sessionStorage.setItem("employmentId", formData.employmentId)
        sessionStorage.setItem("EmploymentRefId", formData.employmentRefId)
        window.location.href = props.path2
 };
     const editpage = async () => {

        sessionStorage.setItem("employmentId", formData.employmentId)
         sessionStorage.setItem("EmploymentRefId", formData.employmentRefId)
         window.location.href = "NCSCDA-Edit?data=5"
 };





    useEffect(() => {
        if (Number(props.year) > 0 && Number(props.month) > 0) {
            getdata()
        }

        console.log(props.year, props.month)
    }, [props.year, props.month])



    return (
        load ? null :
            
                <td  >
                    {formData.activeStatus === "A" ? <Button onClick={(ev) => {
                        ev.preventDefault();
                    editpage();
                    }} style={{ backgroundColor: "#f9db7b", color: "white", borderColor: "white" }} >
                        <b style={{ fontSize: 18 }}> Edit <em class="icon ni ni-pen2"></em></b>
                    </Button> : formData.activeStatus === "S" ? <Button 
                            color="success" onClick={(ev) => {
                                ev.preventDefault();
                            viewpage();
                            }} >
                            <b style={{ fontSize:18 }}>View <em class="icon ni ni-eye-fill"></em></b>
                        </Button> : <Button onClick={(ev) => {
                            ev.preventDefault();
                                check()
                            }} style={{ backgroundColor: "#e85347", color:"white" }} >
                            <b style={{ fontSize: 18 }}> Add <em class="icon ni ni-property-add"></em> </b>
                        </Button> }
                    
                </td>

        
    );
};

export default AdminUserDataUpdate;
